import React from 'react'
import './loader.css'

const Loader = () => {
  return (
    <div  className="loader" style={{width:"70px", margin:"10px"}}></div>
  )
}

export default Loader
